import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { OneWaitlistDocument, UpsellLandingPagesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useGetDatoModules } from 'modules/marketplace_modules/hooks/useGetDatoModules'
import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'
import { SelfUpsellProvider } from 'modules/upsell/store/SelfUpsellProvider'

import OneLandingHeader from './OneLanding/_Header'
import Sections from './OneLanding/_Sections'
import SectionsHeader from './OneLanding/_SectionsHeader'

const OneLandingPage = () => {
  const queryParams = new URLSearchParams(location.search)

  const {
    company: { id: companyId },
    access: { locale: accessLocale },
  } = useCurrentSession()
  const locale = getDatoLocale(accessLocale)

  const { data, loading } = useQuery(UpsellLandingPagesDocument, {
    variables: {
      locale: locale,
      preview: true,
      slug: 'one',
    },
  })

  const { data: oneWaitlistData, loading: oneWaitlistLoading } = useQuery(OneWaitlistDocument, {
    variables: {
      companyId: companyId,
    },
  })

  const { data: moduleData, loading: moduleLoading } = useGetDatoModules({
    locale: locale,
    slug: 'one',
    showHiddenModules: true,
  })

  const content = data?.upsell.landingPagesConnection.edges[0]?.node

  useEffect(() => {
    track(trackingEvents.upsell.viewOneLandingPage, {
      utm_source: queryParams.get('utm_source'),
    })
  }, [])

  if (loading || moduleLoading || oneWaitlistLoading) return <Spinner />

  const alreadyInOneWaitlist =
    oneWaitlistData?.companies.featureAvailabilitiesConnection.nodes[0]?.available === true

  const canJoinOneWaitlist = !!oneWaitlistData?.upsell._policies.canJoinOneWaitlist.can

  return (
    <SelfUpsellProvider
      availableAddons={moduleData?.at(0)?.billingAddonReference || []}
      availableCrossSellingAddons={moduleData?.at(0)?.crossSellingBillingAddonReference || []}
      availableMandatoryCrossSellingAddons={moduleData?.at(0)?.mandatoryCrossSellingAddons || []}
      moduleName={moduleData?.at(0)?.chargebeeModuleName || ''}
    >
      <ResponsivePage.Body variant="full" showHeader={false} authorized={canJoinOneWaitlist}>
        <Box gap="s40" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <OneLandingHeader
            content={content}
            billingAddon={moduleData?.at(0)?.billingAddonReference?.[0] || null}
            moduleName={moduleData?.at(0)?.chargebeeModuleName || ''}
            alreadyInOneWaitlist={alreadyInOneWaitlist}
          />
          <SectionsHeader content={content} />
          <Sections
            content={content}
            billingAddon={moduleData?.at(0)?.billingAddonReference?.[0] || null}
            moduleName={moduleData?.at(0)?.chargebeeModuleName || ''}
            alreadyInOneWaitlist={alreadyInOneWaitlist}
          />
        </Box>
      </ResponsivePage.Body>
    </SelfUpsellProvider>
  )
}

export default OneLandingPage
